import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';

import {BienvenidoComponent} from "./bienvenido/bienvenido.component";
// d3 and nvd3 should be included somewhere
import 'd3';
import 'nvd3';
import {MomentModule} from "angular2-moment";
import {MaterialModule} from "../../../material.module";
import {HelperBienvenidoComponent} from "./helper/helperBienvenido.component";
import {NvD3Module} from "ng2-nvd3";
import {LoadingModule} from "../../../autenticacion/loadingScreen/loading.module";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        NvD3Module,
        MaterialModule,
        MomentModule,
        LoadingModule
    ],
    declarations: [BienvenidoComponent, HelperBienvenidoComponent]
})
export class HomeModule {
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/home/home.module.ts